module.exports = __webpack_public_path__ + "static/fonts/Nunito-Bold.3f203fa.woff2";